import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'feet', label: 'Feet' },
  { key: 'met',  label: 'Meters' },
  { key: 'inch', label: 'Inches' },
  { key: 'yard', label: 'Yards' },
  { key: 'mile', label: 'Miles' },
  { key: 'km',   label: 'Kilometers' },
  { key: 'mm',   label: 'Millimeters' },
  { key: 'fur',  label: 'Furlong' },
];

// factors[unit] = value_in_unit when base = 1 (base = feet)
const factors = {
  feet: 1,
  met:  1 / 3.281,
  inch: 12,
  yard: 1 / 3,
  mile: 1 / 5280,
  km:   1 / 3280.84,
  mm:   304.8,
  fur:  1 / 660.001,
};

export const ConvLength = () => (
  <UnitConverter
    title="Length"
    units={units}
    factors={factors}
    explanationTitle="Units of length"
    explanation="1 inch = 0.0254 metres; 1 mile = 1.60934 kilometres. In the English system, one mile is approximately 1.61 times a kilometre (metric) - a mile is 0.61 more than a kilometre and an inch is 0.0254 times a metre."
  />
);
